import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AllRoles, UserRoles } from './core/enumurations/user-roles.enum';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './shared/layout/layout.component';

const appRoutes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'home',
        component:LayoutComponent,
        children:[
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                data: {
                    breadcrumb: 'Accueil'
                },
                canActivate: [AuthGuard]
            },
            {
                path: 'settings',
                loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
                canActivate: [AuthGuard],
                data: {
                    roles: AllRoles.filter(role => role !== UserRoles.ENSEIGNANT)
                }
            },
            {
                path: 'users',
                loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
                canActivate: [AuthGuard],
                data: {
                    roles: AllRoles.filter(role => role !== UserRoles.ENSEIGNANT)
                }
            },
            {
                path:'apprenants',
                loadChildren: () => import('./apprenants/apprenants.module').then(m => m.ApprenantsModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'groups',
                loadChildren: () => import('./groups/groups.module').then(m => m.GroupsModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'calendars',
                loadChildren: () => import('./calendars/calendars.module').then(m => m.CalendarsModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'profile',
                loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'home/dashboard',
        pathMatch: 'full',
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes,{ useHash : false ,scrollOffset: [0, 0],scrollPositionRestoration: 'top' })
    ],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule { }
